import { showNotification } from '@mantine/notifications';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { NotificationsKey } from 'src/i18next';

type NotificationType = {
  title: NotificationsKey;
  message: NotificationsKey;
};

type ErrorNotificationType = NotificationType & {
  error: AxiosError;
};

type UseNotificationReturnType = {
  showError: ({ title, message, error }: ErrorNotificationType) => void;
  showSuccess: ({ title, message }: NotificationType) => void;
};

export const useNotification = (): UseNotificationReturnType => {
  const { t } = useTranslation('notifications');

  const showError = ({ title, message, error }: ErrorNotificationType) => {
    const hasError = error?.message === 'string';
    showNotification({
      color: 'red',
      position: 'top-right',
      title: t(`${title}`),
      message: hasError ? error.message : t(`${message}`),
    });
  };

  const showSuccess = ({ title, message }: NotificationType) =>
    showNotification({
      color: 'green',
      position: 'top-right',
      title: t(`${title}`),
      message: t(`${message}`),
    });

  return {
    showError,
    showSuccess,
  };
};
